import { SET_THEME_MODE, SET_IS_SYSTEM_THEME, SET_IS_LOGOUT, SET_COMPANY_LOGO } from "redux/constants/portal";

export const setThemeMode = (payload) => ({
   type: SET_THEME_MODE,
   payload
});
export const setIsSystemTheme = (payload) => ({
   type: SET_IS_SYSTEM_THEME,
   payload
});
export const setIsLogout = (payload) => ({
   type: SET_IS_LOGOUT,
   payload
});
export const setCompanyLogo = (payload) => ({
   type: SET_COMPANY_LOGO,
   payload
});
